import { Trans } from "react-i18next";
import { Link, Typography } from "@mui/material";
import { useBrandingContext } from "context/BrandingContext";
import { Center } from "components/layout/reusableLayouts";

interface TermsAndPrivacyNoticeProps {
  className?: string;
}

/**
 * The passive form: submitting is the agreement, so there is nothing to tick.
 * Where consent has to be given explicitly, use TermsAcceptanceCheckbox.
 */
const TermsAndPrivacyNotice: React.FC<TermsAndPrivacyNoticeProps> = ({
  className,
}) => {
  const { platform } = useBrandingContext();

  // Not "": an empty href resolves to the current page, so target="_blank"
  // would reopen the app in a new tab when a platform configures no link.
  const termsUrl = platform?.termsUrl || undefined;
  const privacyUrl = platform?.privacyUrl || undefined;

  return (
    <Center className={className} sx={{ width: "100%" }}>
      <Typography
        variant="body2"
        component="p"
        sx={{ color: "var(--color-text-tertiary)" }}
      >
        <Trans i18nKey="termsAndPrivacy">
          By clicking submit, you agree to the
          {termsUrl ? (
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href={termsUrl}
              underline="hover"
            >
              Terms
            </Link>
          ) : (
            <span>Terms</span>
          )}
          and
          {privacyUrl ? (
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href={privacyUrl}
              underline="hover"
            >
              Privacy Policy
            </Link>
          ) : (
            <span>Privacy Policy</span>
          )}
        </Trans>
      </Typography>
    </Center>
  );
};

export default TermsAndPrivacyNotice;
